import React from 'react';
import { CTAButton } from './CTAButton';
export function Pricing() {
  return <section className="bg-[#FFFEF7] py-6 md:py-12 lg:py-[60px]" id="pricing" data-id="element-119">
      <div className="container mx-auto px-4" data-id="element-120">
        <div className="max-w-4xl mx-auto bg-white rounded-[24px] shadow-[0_10px_50px_rgba(0,0,0,0.1)] overflow-hidden border-2 border-[#FFD700]" data-id="element-121">
          <div className="bg-[#1B3A6B] py-4 md:py-5 text-center text-white" data-id="element-122">
            <h2 className="font-poppins font-bold text-[20px]" data-id="element-123">
              OFERTA DE LANZAMIENTO
            </h2>
          </div>

          <div className="p-6 md:p-8 lg:p-10 text-center" data-id="element-124">
            <h3 className="text-[#1B3A6B] font-poppins font-black md:text-5xl mb-3 text-[20px]" data-id="element-125">
              CÓDIGO DE EMERGENCIA ESCOLAR™
            </h3>
            <p className="text-[#FF6B35] font-poppins font-bold text-xl mb-5 md:mb-6" data-id="element-126">
              NIVEL PRIMARIO · PACK COMPLETO
            </p>

            <div className="flex flex-col items-center mb-6 md:mb-8" data-id="element-127">
              <span className="text-[#555555] line-through text-xl mb-1" data-id="element-128">
                $27.990
              </span>
              <div className="flex items-baseline gap-2" data-id="element-129">
                <span className="text-[#1B3A6B] font-poppins font-black md:text-8xl text-[48px]" data-id="element-130">
                  $19.990
                </span>
                <span className="text-[#1B3A6B] font-bold" data-id="element-131">ARS</span>
              </div>
              <p className="text-[#555555] mt-2 md:mt-3 font-medium" data-id="element-132">
                Pago único · Acceso de por vida
              </p>
            </div>

            <div className="md:space-y-3 mb-6 md:mb-8 max-w-md mx-auto text-left space-y-[-4px]" data-id="element-133">
              <div className="flex items-center gap-3" data-id="element-134">
                <span className="text-[#2D9B6F]" data-id="element-135">✅</span>
                <span className="text-[#2C2C2C] font-medium" data-id="element-136">
                  4 Módulos de formación y acción
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-137">
                <span className="text-[#2D9B6F]" data-id="element-138">✅</span>
                <span className="text-[#2C2C2C] font-medium" data-id="element-139">
                  3 Bonos exclusivos de regalo
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-140">
                <span className="text-[#2D9B6F]" data-id="element-141">✅</span>
                <span className="text-[#2C2C2C] font-medium" data-id="element-142">
                  260+ páginas de material listo
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-143">
                <span className="text-[#2D9B6F]" data-id="element-144">✅</span>
                <span className="text-[#2C2C2C] font-medium" data-id="element-145">
                  Acceso inmediato por email
                </span>
              </div>
            </div>

            <CTAButton href="https://checkout.guiadigital360.online/cart/45019141144645:1" className="w-full max-w-lg mx-auto mb-4" data-id="element-146">
              → DESCARGAR EL PACK AHORA
            </CTAButton>

            <div className="flex flex-wrap justify-center gap-4 items-center" data-id="element-147">
              <img src="https://logodownload.org/wp-content/uploads/2019/06/mercado-pago-logo.png" alt="Mercado Pago" className="h-6 opacity-60" data-id="element-148" />
              <p className="text-[#555555] text-sm font-medium" data-id="element-149">
                Pago 100% Seguro
              </p>
            </div>
          </div>
        </div>

        <div className="mt-6 md:mt-8 text-center" data-id="element-150">
          <p className="text-[#555555] mb-3" data-id="element-151">
            ¿Tenés dudas o preferís transferencia?
          </p>
          <CTAButton isWhatsApp href="https://wa.me/5492966244076?text=Hola%2C%20vengo%20de%20la%20p%C3%A1gina%20de%20C%C3%B3digo%20de%20Emergencia%20Escolar%20Nivel%20Primario%20y%20quiero%20finalizar%20mi%20compra%20del%20pack%20completo.%20%F0%9F%9A%A8" className="mx-auto" data-id="element-152">
            HABLAR POR WHATSAPP
          </CTAButton>
        </div>
      </div>
    </section>;
}